var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-link',{staticClass:"site-link text-nowrap",attrs:{"href":_vm.href,"target":"_blank","disabled":!_vm.siteId}},[_c('span',[_vm._v("Open in LandInsight")]),_vm._v(" "),_c('b-icon',{staticClass:"ml-1",attrs:{"icon":"box-arrow-up-right"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }